import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/workplace-xg/workplace-xg/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import ImageCollection from "../../../components/ImageCollection";
import TypefaceSubFamilies from "../../../components/TypeFaceSubFamilies";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const Caption = makeShortcode("Caption");
const ArtDirection = makeShortcode("ArtDirection");
const ResourceCard = makeShortcode("ResourceCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`The IBM signage system serves as an important communication guide for our guests throughout our spaces. Thoughtfully created to provide a unified brand design, the system offers flexibility in finishes.`}</p>
    </PageDescription>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Interior signage</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Typography</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Pictograms</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Employee recognition program</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Distraction film</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Exterior signage</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Environmental impact</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Resources</AnchorLink>
    </AnchorLinks>
    <Row mdxType="Row">
  <Column colLg={8} colMd={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAAQF/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAABwrY7jOB//8QAGhAAAgIDAAAAAAAAAAAAAAAAAAIBMRITIv/aAAgBAQABBQJb1xiLazyf/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAFxAAAwEAAAAAAAAAAAAAAAAAAAEQgf/aAAgBAQAGPwIyuf/EABoQAAICAwAAAAAAAAAAAAAAAAEQESEAMWH/2gAIAQEAAT8hCcWTR2ZCLhX/2gAMAwEAAgADAAAAEEDP/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPxA//8QAGRAAAwEBAQAAAAAAAAAAAAAAAAERITGh/9oACAEBAAE/EEJT4JUbK45glhM1xGhXLwXD/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Tactile IBM Bee sign",
            "title": "Tactile IBM Bee sign",
            "src": "/workplace-xg/static/1b50781f63d7471f4aa384649561540f/2e753/tactile-ibm-bee-sign.jpg",
            "srcSet": ["/workplace-xg/static/1b50781f63d7471f4aa384649561540f/69549/tactile-ibm-bee-sign.jpg 288w", "/workplace-xg/static/1b50781f63d7471f4aa384649561540f/473e3/tactile-ibm-bee-sign.jpg 576w", "/workplace-xg/static/1b50781f63d7471f4aa384649561540f/2e753/tactile-ibm-bee-sign.jpg 1152w", "/workplace-xg/static/1b50781f63d7471f4aa384649561540f/a052a/tactile-ibm-bee-sign.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </Column>
  <Column colLg={4} colMd={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100.34722222222223%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGQABAQEAAwAAAAAAAAAAAAAAAAIDAQQF/8QAFQEBAQAAAAAAAAAAAAAAAAAAAQD/2gAMAwEAAhADEAAAAcL1gqcJ87riUC//xAAcEAACAgIDAAAAAAAAAAAAAAABAgASAxMEESH/2gAIAQEAAQUCoJVLawZsMORXdeQAD3UMwgPn/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAHRAAAgIDAAMAAAAAAAAAAAAAAQIAERASISIxQf/aAAgBAQAGPwI3KU3hvAED3N1WtVn2HpnGIx//xAAZEAEAAwEBAAAAAAAAAAAAAAABABEhMVH/2gAIAQEAAT8hpUqBlikhLBqdmQycglCoo8lEsbEKNO72Wux2mJH/2gAMAwEAAgADAAAAEJwAAv/EABYRAQEBAAAAAAAAAAAAAAAAABEAEP/aAAgBAwEBPxBnf//EABURAQEAAAAAAAAAAAAAAAAAABEg/9oACAECAQE/ECP/xAAbEAEAAwEBAQEAAAAAAAAAAAABABEhMUHRYf/aAAgBAQABPxBd4EQL7fyWqUcQNM+zaE4obBlMy2C3rHrIvmW65XtREtSiGIiiB1r2U8LIUs/ZUW3P/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Distraction film on glass",
            "title": "Distraction film on glass",
            "src": "/workplace-xg/static/ab0a646c2bd8451f91097eb50d6c435c/473e3/distraction-film-on-glass.jpg",
            "srcSet": ["/workplace-xg/static/ab0a646c2bd8451f91097eb50d6c435c/69549/distraction-film-on-glass.jpg 288w", "/workplace-xg/static/ab0a646c2bd8451f91097eb50d6c435c/473e3/distraction-film-on-glass.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </Column>
    </Row>
    <h2>{`Interior signage`}</h2>
    <p>{`Signage and wayfinding should fit unobtrusively into the environment and support a user’s journey through the space. Materiality and scale are flexible in response to different project and space requirements. Various finishes may be used based on budget and production limitations. All signage should be considered an extension of the interior design and complement the surrounding materials.`}</p>
    <p>{`Always integrate interior code signage and wayfinding with the visual aesthetic of the architectural space. They should serve as an extension of the interior design. Create code signage in a neutral tone. For accessibility, panels with typography and pictograms should have at least a 70% contrast level between the text and panel color.`}</p>
    <p>{`Use back-painted color accents on all amenity and restroom signs. Choose an accent color directly from the `}<a parentName="p" {...{
        "href": "https://www.ibm.com/design/language/color"
      }}>{`IBM Design Language color guidelines`}</a>{`. Signage with a back-painted color accent provides a nice complement to the architectural and furniture finishes in the space.`}</p>
    <ImageCollection className="mt-32" mdxType="ImageCollection">
  <Column colLg={12} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "67.0138888888889%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAMEBf/EABUBAQEAAAAAAAAAAAAAAAAAAAEC/9oADAMBAAIQAxAAAAGXZ0TooJf/xAAZEAADAQEBAAAAAAAAAAAAAAABAgMAERL/2gAIAQEAAQUCnGoogbL3hwGUeR//xAAWEQEBAQAAAAAAAAAAAAAAAAACEBH/2gAIAQMBAT8BJyf/xAAYEQACAwAAAAAAAAAAAAAAAAABAwIQIf/aAAgBAgEBPwFjDM7X/8QAGxAAAQQDAAAAAAAAAAAAAAAAAQACEBEiQYH/2gAIAQEABj8CaSw1cZG531f/xAAaEAADAQADAAAAAAAAAAAAAAABESEAMVFx/9oACAEBAAE/IRMQUcwbVCsAwF2AtwOYwzRojL09/9oADAMBAAIAAwAAABC/D//EABYRAQEBAAAAAAAAAAAAAAAAAAEQEf/aAAgBAwEBPxAA5P/EABURAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAECAQE/EBLH/8QAHRABAQEAAgIDAAAAAAAAAAAAAREAYXEhMVGRwf/aAAgBAQABPxAQWFD0YxyJfAf3QVDwHWPm4wWgIUYnWKEtto+9/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM Logos",
            "title": "IBM Logos",
            "src": "/workplace-xg/static/28f87a6ea86e681ed9230929d136157d/2e753/interior-signage-ibm.jpg",
            "srcSet": ["/workplace-xg/static/28f87a6ea86e681ed9230929d136157d/69549/interior-signage-ibm.jpg 288w", "/workplace-xg/static/28f87a6ea86e681ed9230929d136157d/473e3/interior-signage-ibm.jpg 576w", "/workplace-xg/static/28f87a6ea86e681ed9230929d136157d/2e753/interior-signage-ibm.jpg 1152w", "/workplace-xg/static/28f87a6ea86e681ed9230929d136157d/040c5/interior-signage-ibm.jpg 1200w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </Column>
  <Column colLg={4} colMd={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100.34722222222223%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAACIElEQVQ4y82SzUpqURiGl3YJpWYjBX9plpTiD85FxVC7g8qJmXgFJk78C5yq4EQTpbnorCjqIpr7M8rajmq/7e+DLXXA6EAczoKH95ush/djLSHLsrSO9/d3CYA0nU4lo9EoCSEkjUbDuRb84MxmMyhCKBegCDnXIn9zlIay4pOVhrIilJULsiLkXMt3zRQhpyL8q4ZYx/8h/Kcrv729sXAymfxOQ/XM5/OfC19eXqDy+vrKuVgsmOfnZyyXSzw9PWFnZ4cvbGxsQKvVMiT/E3FycgKV09NTHB8fIx6PIxaLMYeHhwiHw7DZbDCZTDCbzQzNW1tb2Nzc/IKIRCIg6BJlKBTC/v4+9vb24HK5GJodDgdL7XY7Q7PBYIBer/+CoDYqiUSCGwUCAXi9Xsbn88Hj8bDQarWyiKCZhDqd7qtQXU1dLxqNssjtdjMkOzg4YInFYmERQTMJaG2SqoijoyMQyWSSk5oGg0H4/X6G2lLL3d1dOJ3OFdSYHmp7e5t/gIoYjUZQGY/HGA6HaLfbaDabaLVaTKPRQLFYxMXFBQqFApPP55FKpfgRPz+seHh4gMrj4yPu7+9xfX2Nfr/PDAYD9Ho91Ot11Go1XF5eMtVqFblcDufn58hmsyvE3d0dPnNzc8OibreLq6srptPpsKRcLqNSqTClUoll6XQaZ2dnKwQ1IkhGeXt7y0ISUTNCFZKImhEkp0YkyWQyK35d+AEQlqY4K7r+pgAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "gray palette",
            "title": "gray palette",
            "src": "/workplace-xg/static/379de626800204e7db6ea84ac02d8f78/a5df1/interior-signage-gray-palette.png",
            "srcSet": ["/workplace-xg/static/379de626800204e7db6ea84ac02d8f78/7fc1e/interior-signage-gray-palette.png 288w", "/workplace-xg/static/379de626800204e7db6ea84ac02d8f78/a5df1/interior-signage-gray-palette.png 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Create code signage in a neutral tone.</Caption>
  </Column>
  <Column colLg={8} colMd={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIEAwX/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAAB6SPDFxmH/8QAGhAAAgMBAQAAAAAAAAAAAAAAAQIAAxESQf/aAAgBAQABBQL0uoO7MltBc1ryn//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABkQAQACAwAAAAAAAAAAAAAAAAEAEQIQUf/aAAgBAQAGPwKUu7GGPJ//xAAZEAEBAQADAAAAAAAAAAAAAAABEQAhMWH/2gAIAQEAAT8hvTHwi4Ao0zW4zX3K82Jd/9oADAMBAAIAAwAAABBL7//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8QP//EABkQAQADAQEAAAAAAAAAAAAAAAEAESFRcf/aAAgBAQABPxDe4FXESFgwiZNEbGB67Fw0oQYFQEDwMuf/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "signage substrate examples",
            "title": "signage substrate examples",
            "src": "/workplace-xg/static/0c12d8bd8315d683f0952a79f1a1ae21/2e753/signage-substrate-examples.jpg",
            "srcSet": ["/workplace-xg/static/0c12d8bd8315d683f0952a79f1a1ae21/69549/signage-substrate-examples.jpg 288w", "/workplace-xg/static/0c12d8bd8315d683f0952a79f1a1ae21/473e3/signage-substrate-examples.jpg 576w", "/workplace-xg/static/0c12d8bd8315d683f0952a79f1a1ae21/2e753/signage-substrate-examples.jpg 1152w", "/workplace-xg/static/0c12d8bd8315d683f0952a79f1a1ae21/a052a/signage-substrate-examples.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </Column>
  <Column colLg={8} colMd={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIFAwT/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAHZ+ieUhQ//xAAaEAADAQADAAAAAAAAAAAAAAABAgMEABAR/9oACAEBAAEFAr2MmTQj9EBhTIDxR4v/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAdEAACAQQDAAAAAAAAAAAAAAAAARECECEiMVFh/9oACAEBAAY/AqccnT9tDUmjgSP/xAAbEAEAAgIDAAAAAAAAAAAAAAABABEhYRAxUf/aAAgBAQABPyEAAgzMVerhWENyybPj1NAAT//aAAwDAQACAAMAAAAQsM//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/ED//xAAdEAEAAgICAwAAAAAAAAAAAAABABEhMUFRwdHh/9oACAEBAAE/EHxcbb2HmVOUx9IIljYxYg8C4Omx2e0RpFvDmip//9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "backpainted signage examples",
            "title": "backpainted signage examples",
            "src": "/workplace-xg/static/a215e9074ad31efcdccb26ad36939a29/2e753/backpainted-signage-examples.jpg",
            "srcSet": ["/workplace-xg/static/a215e9074ad31efcdccb26ad36939a29/69549/backpainted-signage-examples.jpg 288w", "/workplace-xg/static/a215e9074ad31efcdccb26ad36939a29/473e3/backpainted-signage-examples.jpg 576w", "/workplace-xg/static/a215e9074ad31efcdccb26ad36939a29/2e753/backpainted-signage-examples.jpg 1152w", "/workplace-xg/static/a215e9074ad31efcdccb26ad36939a29/a052a/backpainted-signage-examples.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </Column>
  <Column colLg={4} colMd={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100.34722222222223%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAAEBElEQVQ4y63U+0/VdRzH8Q+bgrNJmm39Uv3Qkub6vZUXSLw1tyaI5tpqSyxb3oDQAuSAIipeagMPIEcPosBRLgkruZ0L4pyXasXNC6j9XGpgun3d8Jzzfvb+ngOH/oB+eOzz22vPN3x3DG1DVsSFwejb3G9R0m3h6LCkqMOiqNMKF/xkPd5YY42lV1pjGVXWuPo77bg1tDDX6l+QZQ0kZccY2oeJaJt8WwZgfw84OqGoC4rVnos82ehifF0VjzPU+mrG0pwML8xlYEEWg0nZMUbahiTigmpXLf0iJT0ijg6Ros4ILRQtlLF1laKFMp5RLY/SnKKFooXSn5QdY/RUYtpU8+9QolWFF7VSFXUg+T/yz0fVjKcf5/E6p1Y6GVtbroXZDLy5ncEFO2JMqO0mMe23CLUM8bw0wPMiL8+LvQT3+pjY083Dj0/zV8YpHqx382CDmz/TXfz2diG/JOXx61v5MWa0Z4IY7wR3Oie4XvmMq+Wq4hnX1JXvLdp3PuWHr9TWp1zY9pTWL5/gTHlE+aKHVCx5RMXiKDPkgynDfhjsht4a8DnBX6mqwFsBjV/D2R1Qv1NlwZltcGQ5HEqGspRp5qZXsA3br08Y6hL6TggBp9BrqxR85cK5HKFhh9C4M6p+m3AsNcjh5CBHUvSdpIMw5ZZdqv+Pyye08rjSyks66C+H8zlauR08OurRyoatwnepIY4uDXI0eZoZ1BHbgP3qyf16sk9P7tFze6oEbzV0VQhncoVaLavNEk5ng3u7ULoyxL73Q5Qsm2Zarum3PKn1upZcgdIm/Z4bYa9H2HdOv6B6YcNhYW2pkHZASD8ofLhfeGNTmFc/CfP6p2Fem2Qabmj+pEZVdxUKWmH3eaXD3zQLOR5YfQyWHYZUtfwIJB8S5m4RZmcKL2xWmVHGc13/JqrRfm8IZ68KhS3Ct+eFPJXfJORq6ZpjwooyYaVapbWpWvnyF2EStXJuZpgXN0WZc3qmzWO/WlivhY4WdAzyVYFW7tLCNVq4ogwdRAe19CDM/xwSP0OHppmzN8JMqf85TO21MHmtIXKbQuxSu5tDZHlCenKQZWVBPTmoJwdJORTkpS0TzMmcIHGzyowyq0fvY1s1cp8PRv8g9fZdXglcYZ63j/k+22XmdfeSUOsh3lVP/ElbA/E1Z4hzlBGXf4C4goPqQIRZdG+EqDssvj/COyO3mN3nY4a/i5mBbmb2djPD24Gpc2FOVWHc1eoE5mQlZm8epnA3xvEfS++OMiX53ijvjdxmzqUACf4eZvm9zAr4SPB2EVfn1sEapcPukxiXjhYX6qD+IDjyo69tqY7YltwdiQy+Gxn0Ex8ZVAFvZNBMDbpdUS4tLd6jI3nRwSn/9+C/vkl72rlmi5QAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "interior signage color palette",
            "title": "interior signage color palette",
            "src": "/workplace-xg/static/03a64c439ef9fa391f31061d7d376220/a5df1/interior-signage-color-palette.png",
            "srcSet": ["/workplace-xg/static/03a64c439ef9fa391f31061d7d376220/7fc1e/interior-signage-color-palette.png 288w", "/workplace-xg/static/03a64c439ef9fa391f31061d7d376220/a5df1/interior-signage-color-palette.png 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  Use back-painted color accents on amenity and restroom signage.
        </Caption>
  </Column>
    </ImageCollection>
    <h2>{`Typography`}</h2>
    <h3>{`Tactile characters`}</h3>
    <p>{`The IBM Plex® is our corporate typeface. It has been carefully designed to meet our needs as a global technology company by reflecting our brand spirit, beliefs and design principles. IBM Plex Sans Regular meets the Americans with Disabilities Act (ADA) code requirements for tactile characters and should be used in all instances where tactile characters are required. Where numbers are needed, use IBM Plex Mono.`}</p>
    <Row mdxType="Row">
  <Column colLg={8} colMd={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100.34722222222223%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAACPUlEQVQ4y61UW0uiURT9tJQ0lcQLindKSKEiUkx8SUTzHnlJy7RSQkkCIfAp8Ff3etacvYfP0dSaYXpYnNt31l577X0+RVGUj0VoNBrGuv2v1gtQIA+xvb0NmquwWCyw2+3QarUMdd/lci2t10AR8qJ4fX0VNA8Gg8JgMIjb21vR7XZFpVIRpVJJ7O7uilQqJe7v70UoFBKBQEBIcr7zCQouLy8xm80QjUbR6XTQbrfx8PAAeRmPj4+QpOj1enh5eWEVR0dHaDQacLvdqwq3trZQr9eRy+X48ng8ZtJ+v89rIifCarWKq6srFItFSMW8ltlAtWxOuOidTJU9otFqtTJo3+v1sqfqnEan0zk//+whm394eDjf3NnZgdFoRDgcnhMRPB4PfD4fzGYzTCbTqjqV8ObmBrIIOD8/hzQbw+GQ0yMrbDYbe0vKRqMRB356ekI+n2eCNRVXUC6Xsbe3h7e3NzSbTTZcVpi9k5XF+/s7B51Op4hEImi1Wjg9Pd2ssFarcdSLiwsUCgUmJAU0xuNxPqORuoG+Pzs74/Q39SF0Ot1cOnkje44jU7rqh4vFo2/XKPtDSFVNJBIrVaNADocDJycnPP/idSwTkleZTAYHBweMu7s7VkD+pdNpbvBkMrnJs2VQi1A19/f32ezn52cGHVIB6DVks9lNPbdeIaVLL+L6+hqTyQSDwQCxWAzHx8fw+/08/iXZb0KCXq9n4yl1skBVRCl+83dZJfzWl3/D8gaR/2cABT+MnyX8BY+m826urXJZAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "signage typography example",
              "title": "signage typography example",
              "src": "/workplace-xg/static/5b48259830fc954eeb98ee1df2852e5a/a5df1/signage-typography-example-mobile.png",
              "srcSet": ["/workplace-xg/static/5b48259830fc954eeb98ee1df2852e5a/7fc1e/signage-typography-example-mobile.png 288w", "/workplace-xg/static/5b48259830fc954eeb98ee1df2852e5a/a5df1/signage-typography-example-mobile.png 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.25%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAABzklEQVQoz61SyYpiQRB8tqLirihu7Yob7jvuuyKoqLR4EAR/wz9vPGRMZjXKOMzc5hCvinxVEZEZpWma9njCaDQ+DAbDQ6/XPz4+Pl775ypnZLXb7ar2+90XCoUCttstBoMB7vc7JpMJFosF2u025vM5ptMprtcrTqcTRqMRjsej2suZ3W6HQCAAJoJOp1OrxmoUjUYpm81Sq9WiTCZDyWSS4vG4qgtYlBKJBEUiEXI6neRwOIiJiAnp8/OTmIiYUK2aKFSrVeWQL4OJ0Gg0lNN6vY5QKIRisYher4dSqYRarYZOpwPprFwuI5/P/zh7ghVQqVTQ7/fVoVwuh9lsplqSmogJSTqdRrPZRLfbfQmKAHf0TigfcSE/uH1F6PF4EIvFwC2C24ff74fX60UqlYLP54PValWQjkwm0zuhWD6fz0r9crlgPB7j6+sLt9tNuRBsNhs1EglKApRw1us1DoeDcvtGKEo8ZPAzgc1mg4zA5XIhGAyqA/KPg1BOZC9d8POC2WxWyfIzeieUBNkN8cyIlWm/3xMPnVarFfEMablc0nA4JBYgdkos+pPmv2CxWNQMZR4CST0cDisnkqLUZJZut1vV/gjgb9C+/yd+ASxsIzyGeUYIAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "signage typography example",
              "title": "signage typography example",
              "src": "/workplace-xg/static/20c7bebacdea7fb4f91fb7ffc6525e32/3cbba/signage-typography-example.png",
              "srcSet": ["/workplace-xg/static/20c7bebacdea7fb4f91fb7ffc6525e32/7fc1e/signage-typography-example.png 288w", "/workplace-xg/static/20c7bebacdea7fb4f91fb7ffc6525e32/a5df1/signage-typography-example.png 576w", "/workplace-xg/static/20c7bebacdea7fb4f91fb7ffc6525e32/3cbba/signage-typography-example.png 1152w", "/workplace-xg/static/20c7bebacdea7fb4f91fb7ffc6525e32/92c65/signage-typography-example.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
        <Caption mdxType="Caption">Use IBM Plex Sans Regular for letters.</Caption>
  </Column>
  <Column colLg={4} colMd={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100.34722222222223%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAABjElEQVQ4y81TS48BQRhs8QoHCeIiGY94XMSFk7iQSQzxihkcBEGCI4nf7tq1/X2bGdZhNeuwh0r3dPdU11f1tRBCXH0+35XGD0HgHqFQiEd1CYLBIB73NSBkq9WSw+FQRqNRuVgsZKPRkJVKhee0Vq/XZbfblXRWXcTjLxAoFosYj8d8Qz6fhyJndYfDAbVaDavVCv1+31P+TCFyuRz2+z3S6TTO5zMKhQITz2Yz2LaNzWaD4/GoXTITqDKZpNlssuJMJoNqtcqH/H4/ksmkPiEhEon82AgEAt5aLBZ7KRT2bzQaccKDwQDhcBiWZWG327F30+nU81jLw3a7jclkgl6vh9PpxN9ETuFQKOTffD7XV0ieuQGQUlJTLpfZVwpsvV7DcRwddd+EiUQC2WyWFwzDgOo9bhu3yUulEuLxuL7C+xSJ/M0XciOkUsnDTqcD9Tq8AFxolnojVE8P2+0Wl8sFpmny/LGNXiKknykM8m+5XLLSP5VMnpGPNE+lUl4YbxO+6dVzwg/hnxN+AZFGzx3yNm8JAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "signage number font",
            "title": "signage number font",
            "src": "/workplace-xg/static/65d28f330fb8f7c48fa64ebfa7f601ed/a5df1/signage-number-font.png",
            "srcSet": ["/workplace-xg/static/65d28f330fb8f7c48fa64ebfa7f601ed/7fc1e/signage-number-font.png 288w", "/workplace-xg/static/65d28f330fb8f7c48fa64ebfa7f601ed/a5df1/signage-number-font.png 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Use IBM Plex Mono for numbers.</Caption>
  </Column>
    </Row>
    <h3>{`Visual characters`}</h3>
    <p>{`Typeface selection for visual characters can vary from space to space, depending on the business function and overall look and feel of the space architecture. The IBM Plex weights shown here meet ADA code requirements for visual characters and may be used in instances where visual characters are allowed by code.`}</p>
    <Row mdxType="Row">
  <Column colLg={8} colMd={6} noGutterMd mdxType="Column">
    <TypefaceSubFamilies mdxType="TypefaceSubFamilies" />
  </Column>
    </Row>
    <h2>{`Pictograms`}</h2>
    <p>{`Pictograms visually signal the intended function for our rooms and spaces. Use them on all amenity and restroom signage. You may source art files directly from the IBM Design Language `}<a parentName="p" {...{
        "href": "https://www.ibm.com/design/language/iconography/pictograms/library"
      }}>{`Pictograms library`}</a>{`.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAABH0lEQVQoz61S22qFQAxc7/ejeFdU5Lwogv//Z30q2WZC3VNOKS3lPAzOJmsyk6xSSr2/GEo7jqNt29bgwMXx9TzvW/wZlmUJPs+Kmqahvu8J3Pd92vddeJIktG0bxXFM/AN1XSd55Nq2Fc5NaFkWOSMuCqEiCAJ9qa2qynRGznVd4VmWSR45cOQQ58Y6DEOjUP+EJyt/hdJRFOlhGCSQ57k+z1NUpWmqj+MQBcixLTPHdV3lLvj9ftdFUTwKwgbPSQI8F80zFWWwMU2TWQwKXJZvt5uxWde1iPrV8j+hiO0R25MtsQrZGquS+DzPxKqIlyYcm8e9siyJFQofx5F4SY8tQ/o1A1iBTViDfcwKHK+AC5rRcEFjE6/iq+W3V+IDOzHom9C6NwoAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "signage appropriate pictograms",
        "title": "signage appropriate pictograms",
        "src": "/workplace-xg/static/762b20b9b3977e8a49f33462997d50e7/3cbba/signage-appropriate-pictograms.png",
        "srcSet": ["/workplace-xg/static/762b20b9b3977e8a49f33462997d50e7/7fc1e/signage-appropriate-pictograms.png 288w", "/workplace-xg/static/762b20b9b3977e8a49f33462997d50e7/a5df1/signage-appropriate-pictograms.png 576w", "/workplace-xg/static/762b20b9b3977e8a49f33462997d50e7/3cbba/signage-appropriate-pictograms.png 1152w", "/workplace-xg/static/762b20b9b3977e8a49f33462997d50e7/0b124/signage-appropriate-pictograms.png 1728w", "/workplace-xg/static/762b20b9b3977e8a49f33462997d50e7/0c3f5/signage-appropriate-pictograms.png 1856w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <h2>{`Employee recognition program`}</h2>
    <p>{`Whenever possible, implement our recognition program in new workplaces when naming conference rooms and Collaboration zones. This program recognizes influential employees, from prominent award winners, to those who have worked behind the scenes and helped shape and transform our company into what we are today. A panel on the inside of each room provides a brief biography about these employees—amplifying the cultural experience of our workplaces.`}</p>
    <Row mdxType="Row">
  <Column colLg={4} colMd={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAUDBP/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAGjy6TYtAAA/8QAGxABAQABBQAAAAAAAAAAAAAAAgMBAAQTICH/2gAIAQEAAQUCSwTjcFPV/Yxk+Xp//8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAGxABAAICAwAAAAAAAAAAAAAAAQIRABASICH/2gAIAQEABj8CtwiD7qVZF40df//EABsQAQACAgMAAAAAAAAAAAAAAAEAERBBICEx/9oACAEBAAE/IUXkTvJlW4KAKpqBSgd8f//aAAwDAQACAAMAAAAQiyi+/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPxAf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPxAf/8QAGhABAQEAAwEAAAAAAAAAAAAAAREAIUFRgf/aAAgBAQABPxBh0OsLu9YEE+a4JoABV5NfMdWDJ5iTOhpv/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Employee recognition program example",
            "title": "Employee recognition program example",
            "src": "/workplace-xg/static/ef146782a97f86b95753e83e015750cf/473e3/employee-recognition-program-1.jpg",
            "srcSet": ["/workplace-xg/static/ef146782a97f86b95753e83e015750cf/69549/employee-recognition-program-1.jpg 288w", "/workplace-xg/static/ef146782a97f86b95753e83e015750cf/473e3/employee-recognition-program-1.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </Column>
  <Column colLg={8} colMd={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAAQF/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAdGKuONAH//EABkQAQADAQEAAAAAAAAAAAAAAAIAAxIBBP/aAAgBAQABBQJrJF/XZLDoVefDn//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABoQAQACAwEAAAAAAAAAAAAAAAEAEQIQURL/2gAIAQEABj8CXkCitJ2enK9f/8QAGRABAQADAQAAAAAAAAAAAAAAAREAECFh/9oACAEBAAE/IeG2LMa4K6Q9iJkawea//9oADAMBAAIAAwAAABBbL//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8QP//EABoQAQEBAQADAAAAAAAAAAAAAAERACExQXH/2gAIAQEAAT8Q+jgS7rE1KvBfOuCMiF9ZEmuBB0mFm//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Employee recognition program example",
            "title": "Employee recognition program example",
            "src": "/workplace-xg/static/f6e67427a6419017bd26aeff6d3b6b49/2e753/employee-recognition-program-2.jpg",
            "srcSet": ["/workplace-xg/static/f6e67427a6419017bd26aeff6d3b6b49/69549/employee-recognition-program-2.jpg 288w", "/workplace-xg/static/f6e67427a6419017bd26aeff6d3b6b49/473e3/employee-recognition-program-2.jpg 576w", "/workplace-xg/static/f6e67427a6419017bd26aeff6d3b6b49/2e753/employee-recognition-program-2.jpg 1152w", "/workplace-xg/static/f6e67427a6419017bd26aeff6d3b6b49/a052a/employee-recognition-program-2.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </Column>
    </Row>
    <h2>{`Distraction film`}</h2>
    <p>{`Although a code requirement, distraction film on glass surfaces has the potential to add character to the room. Just like our signage system, we have a flexible palette of design types.`}</p>
    <Row mdxType="Row">
  <Column colLg={8} colMd={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAIDBP/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAFHTMYg/8QAGxAAAgIDAQAAAAAAAAAAAAAAAQIAAwQSEyP/2gAIAQEAAQUCt1ZfMQANLbYuSsrPNf/EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABoQAAMBAQEBAAAAAAAAAAAAAAABAhEhElH/2gAIAQEABj8CmkVu6jUjkoex36eZ0//EABsQAQACAgMAAAAAAAAAAAAAAAEAESExUWFx/9oACAEBAAE/IRcoPLEEUJjuGaXsAKwNwKsiwEO0oLP/2gAMAwEAAgADAAAAEI//AP/EABURAQEAAAAAAAAAAAAAAAAAAAAR/9oACAEDAQE/EKr/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/ED//xAAdEAEAAgICAwAAAAAAAAAAAAABESEAMUFRYbHw/9oACAEBAAE/EAcBZAUZi/eVbGEmij46yVhmh8Mp0GyaZuMBdWEC9zz1kIGQvmbz/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Distraction film glass",
            "title": "Distraction film glass",
            "src": "/workplace-xg/static/586fd783ff0720d7dd1e8441c402188b/2e753/distraction-film-glass.jpg",
            "srcSet": ["/workplace-xg/static/586fd783ff0720d7dd1e8441c402188b/69549/distraction-film-glass.jpg 288w", "/workplace-xg/static/586fd783ff0720d7dd1e8441c402188b/473e3/distraction-film-glass.jpg 576w", "/workplace-xg/static/586fd783ff0720d7dd1e8441c402188b/2e753/distraction-film-glass.jpg 1152w", "/workplace-xg/static/586fd783ff0720d7dd1e8441c402188b/a052a/distraction-film-glass.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </Column>
  <Column colLg={4} colMd={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAQDBf/EABYBAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEAMQAAABmn2ZdNm3IMyWwH//xAAeEAACAgEFAQAAAAAAAAAAAAABAgARAxITISMyM//aAAgBAQABBQLgkns1XNt7X07G2ytMf0n/xAAXEQEAAwAAAAAAAAAAAAAAAAAAARAR/9oACAEDAQE/AWJr/8QAFREBAQAAAAAAAAAAAAAAAAAAARD/2gAIAQIBAT8BIT//xAAdEAABBAIDAAAAAAAAAAAAAAAAARAhMQJREUGB/9oACAEBAAY/AsuUI3ogWzuyG9b/xAAaEAEAAwEBAQAAAAAAAAAAAAABABEhMUFR/9oACAEBAAE/IUbC1PJTqfEODjPSalHnsSH121KCzVS0hRzkAq4dq5//2gAMAwEAAgADAAAAEJ8PPP/EABcRAAMBAAAAAAAAAAAAAAAAABARIQH/2gAIAQMBAT8QSgao/8QAGREAAwADAAAAAAAAAAAAAAAAAAERECEx/9oACAECAQE/EEnCiax//8QAHxAAAgIBBAMAAAAAAAAAAAAAAREAITFBUWHwccHR/9oACAEBAAE/EMhagxW3bjs0n9njiXgQRhJB1hZGGwL7pB6EBEG/sohIMCaVuwF3mWoNxkykslvzP//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Distraction film rebus",
            "title": "Distraction film rebus",
            "src": "/workplace-xg/static/808df58d3780e16a23e318d2dfb78258/473e3/distraction-film-rebus.jpg",
            "srcSet": ["/workplace-xg/static/808df58d3780e16a23e318d2dfb78258/69549/distraction-film-rebus.jpg 288w", "/workplace-xg/static/808df58d3780e16a23e318d2dfb78258/473e3/distraction-film-rebus.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </Column>
    </Row>
    <h2>{`Exterior signage`}</h2>
    <p>{`Exterior signage plays a pivotal role in our workplaces. These signs are the initial physical manifestations of our brand seen by clients and employees on arrival, setting a strong first impression. As with all other aspects of our signage program, align exterior signage precisely using the 2x Grid. The design of our exterior signage and wayfinding should present visual harmony with its natural surroundings, clearly communicate its destination, be void of redundancy and focus on the core characteristic of perspective.`}</p>
    <ImageCollection mdxType="ImageCollection">
  <Column colLg={4} colMd={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGQABAAIDAAAAAAAAAAAAAAAAAAIFAQQG/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAbLQnSx1IIgyD//EABwQAAICAgMAAAAAAAAAAAAAAAECAAMEERAUI//aAAgBAQABBQJ3CL2wXmYfCrbWwgGa4//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8BH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8BH//EABwQAAEEAwEAAAAAAAAAAAAAAAEAAhARITFBgf/aAAgBAQAGPwKygA3Zj1NodjIuf//EABsQAQACAwEBAAAAAAAAAAAAAAEAERAhMWFx/9oACAEBAAE/Idy65qDz8LXFC+JaUaK0YNoh6QBoKx//2gAMAwEAAgADAAAAEHsvvv/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8QH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8QH//EABoQAQEAAwEBAAAAAAAAAAAAAAERACExURD/2gAIAQEAAT8QSd00brijoE4lZw+X+md+dyebwkAm8E9zZ5LATB4h4EMhn//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM exterior signage",
            "title": "IBM exterior signage",
            "src": "/workplace-xg/static/a2beba971ef506619f24de61e21d1242/473e3/exterior-signage-watson.jpg",
            "srcSet": ["/workplace-xg/static/a2beba971ef506619f24de61e21d1242/69549/exterior-signage-watson.jpg 288w", "/workplace-xg/static/a2beba971ef506619f24de61e21d1242/473e3/exterior-signage-watson.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </Column>
  <Column colLg={4} colMd={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGQABAAMBAQAAAAAAAAAAAAAAAAIDBAEF/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAd+W2mPQREoh0H//xAAaEAACAwEBAAAAAAAAAAAAAAABAwACERAS/9oACAEBAAEFArQswxx81SrDD3//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAcEAACAAcAAAAAAAAAAAAAAAABAgAQEiAhMUH/2gAIAQEABj8CgDZPJ1Nlrf/EABsQAQACAgMAAAAAAAAAAAAAAAEAERAhQWGh/9oACAEBAAE/IVUqw4QgzeG10HcW7t8hBKx//9oADAMBAAIAAwAAABBI577/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/EB//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/EB//xAAaEAEBAAIDAAAAAAAAAAAAAAABABFBIVFh/9oACAEBAAE/EKEzu7D2+FlCXAKsIznQlW83XghxAnIMAgv/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Exterior signage top view",
            "title": "Exterior signage top view",
            "src": "/workplace-xg/static/4ea72ef8bca914fee553f779653b98c1/473e3/exterior-signage-topview.jpg",
            "srcSet": ["/workplace-xg/static/4ea72ef8bca914fee553f779653b98c1/69549/exterior-signage-topview.jpg 288w", "/workplace-xg/static/4ea72ef8bca914fee553f779653b98c1/473e3/exterior-signage-topview.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </Column>
    <Column colLg={4} colMd={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAQDBf/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAHpTySR3GY3AB//xAAaEAACAwEBAAAAAAAAAAAAAAACAwABBBAS/9oACAEBAAEFAoT1jBKiHULCKsrbix8L7//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8BH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8BH//EAB4QAQABAgcAAAAAAAAAAAAAAAEAAhIgITEyQVGR/9oACAEBAAY/Apu8hUaMLDiZoQp6wf/EABsQAQEBAAIDAAAAAAAAAAAAAAERACAxIXGR/9oACAEBAAE/IVDtm7Yv1uhApgV0Yd4kj3ctKxLw/9oADAMBAAIAAwAAABC44IL/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/EB//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/EB//xAAcEAEBAQADAAMAAAAAAAAAAAABEQAxQVEhobH/2gAIAQEAAT8QFoD1ZqFg6D+M5LyAjM9Viwh8+vGGAfpX0My68ZLpppv/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Exterior signage corporate",
            "title": "Exterior signage corporate",
            "src": "/workplace-xg/static/a75142ec882fd8f518a94ec30cd4dd01/473e3/exterior-signage-corporate.jpg",
            "srcSet": ["/workplace-xg/static/a75142ec882fd8f518a94ec30cd4dd01/69549/exterior-signage-corporate.jpg 288w", "/workplace-xg/static/a75142ec882fd8f518a94ec30cd4dd01/473e3/exterior-signage-corporate.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </Column>
    </ImageCollection>
    <h2>{`Environmental impact`}</h2>
    <p>{`When selecting materials for your next signage project, consider materials sustainably sourced. When acrylics are needed, specify recycled materials.`}</p>
    <h2>{`Resources`}</h2>
    <p>{`You’ll find detailed specifications regarding signage design and application in the IBM Workplace Design Signage guide. For more about pictograms, visit the IBM pictogram library, design and usage guidance found on the IBM Design Language website.`}</p>
    <Row className="resource-card-group" mdxType="Row">
      <Column colMd={4} colLg={4} noGutterSm mdxType="Column">   
        <ResourceCard subTitle="IBM Workplace Design Signage Guide" aspectRatio="2:1" href="https://ibm.ent.box.com/s/4nm6sc3p4gfh66wc0u0zp2yysa17zchh" mdxType="ResourceCard">
          <img {...{
            "src": "/workplace-xg/a9e17b0f1c6890d78aa783ab7ebd38f6/box.svg",
            "alt": "BOX"
          }}></img>
        </ResourceCard>
      </Column>
      <Column colMd={4} colLg={4} noGutterSm mdxType="Column">   
        <ResourceCard subTitle="IBM pictograms library" aspectRatio="2:1" href="https://www.ibm.com/design/language/iconography/pictograms/library" mdxType="ResourceCard">
          <img {...{
            "src": "/workplace-xg/b37bb2ecb04338da06d25a45e56d1116/bee.svg",
            "alt": "Bee"
          }}></img>
        </ResourceCard>
      </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      